var singleMatchResults = new Array(),
    multipleMatchResults = new Array();

function InitializeAdvancedRadius() {
    $('#FileUpload').uploadify({
        method: 'post',
        swf: '/uploadify/uploadify.swf',
        uploader: '/Home/AdvancedRadiusLists',
        fileTypeDesc: '.txt',
        fileTypeExts: '*.txt',
        auto: true,
        buttonText: 'Upload',
        height: 30,
        width: 100,
        debug: false,
        onUploadProgress: function (file, bytesUploaded, bytesTotal, totalBytesUploaded, totalBytesTotal) {

        },
        onUploadSuccess: function (file, data, response) {
            var results = $.parseJSON(data);
            SetResults(results, $('.radius-upload-section'));
        },
        onUploadStart: function (file) {
            $('#FileUpload').uploadify("settings", "formData", $('#AdvancedRadiusControl').serializeObject());
            $('.radius-results-error').hide();
        },
        onUploadError: function (file, errorCode, errorMsg, errorString) {

        }
    });

    $('.advanced-radius-container input:radio').change(function () {
        $(this).prop('checked', true);
        $('.radius-option').hide();
        $(this).nextAll('.radius-option').show();
        $('.radius-results-section').appendTo('.radius-option:visible');
    });

    $('.radius-option-go').click(function () {
        var $o = $(this);
        $('.radius-results-error').hide();

        $.DotComAjax({
            url: "/Home/AdvancedRadiusLists",
            cache: false,
            success: function (response) {
                SetResults(response, $o);
            },
            async: true,
            type: 'post',
            data: $('#AdvancedRadiusControl').serialize()
        });
    });
}

function SetResults(results, currentGo) {
    if (!results.Data.IsSuccess) {
        currentGo.closest('.radius-option-section').find('.radius-results-error').html(results.Data.ErrorMessage);
        $('.radius-results-error').show();
    } else {
        if (results.Data.SingleMathes.length > 0) {
            var singleMatches = AddMatchResults(results.Data.SingleMathes, singleMatchResults);
            var singleMatchHtml = getRadiusResultsData(singleMatches, "<b>Matched locations</b>");
            $('.radius-single-results .radius-results-data').remove();
            $('.radius-single-results').show().html(singleMatchHtml);
        }

        if (results.Data.MultipleMatches.length > 0) {
            var multipleMatches = AddMatchResults(results.Data.MultipleMatches, multipleMatchResults);
            var multipleMatchHtml = getRadiusResultsData(multipleMatches, "<b>Multiple match locations</b> - the following locations returned more than one result");
            $('.radius-multiple-results .radius-results-data').remove();
            $('.radius-multiple-results').show().html(multipleMatchHtml);
        }

        if (results.Data.InvalidLocations.length > 0) {
            var invalidLocationsHtml = getRadiusResultsData(results.Data.InvalidLocations, "<b>Invalid locations</b> - the following locations were not found");
            $('.radius-invalid-location .radius-results-data').remove();
            $('.radius-invalid-location').show().html(invalidLocationsHtml);
        }

        if (results.Data.InvalidInputs.length > 0) {
            var invalidInputsHtml = getInvalidInputsData(results.Data.InvalidInputs, "<b>Invalid input</b> - the following lines do not match the required format");
            $('.radius-invalid-input .radius-results-data').remove();
            $('.radius-invalid-input').show().html(invalidInputsHtml);
        }

        $('.radius-results-section').show();
        $('.radius-results-section').appendTo('.radius-option:visible');
    }
    InitializeAdvancedRadiusResults();
}

function AddMatchResults(currentMatches, previousMatches) {
    for (var i = 0; i < currentMatches.length; i++) {
        var currentMatch = currentMatches[i];
        var matchExists = false;
        for (var j = 0; j < previousMatches.length; j++) {
            var previousMatch = previousMatches[j];
            if (previousMatch.Latitude === currentMatch.Latitude &&
                previousMatch.Longitude === currentMatch.Longitude &&
                previousMatch.RequestedCount === currentMatch.RequestedCount &&
                previousMatch.MaxDistance === currentMatch.MaxDistance) {
                matchExists = true;
                break;
            }
        }
        if (!matchExists) {
            previousMatches.push(currentMatch);
        }
    }
    return previousMatches;
}

function getRadiusResultsData(matches, matchText) {
    return "<div class='radius-results-data'>" +
        "<div class='match-locations'>" +
        "<div>" +
            matchText +
        "</div>" +
        "</div>" +
        "<div class='match-location-data'>" +
        "<table cellpadding='4' cellspacing='0' border='0' width='100%'>" +
        "<tr style='background-color: #E7E7E7;'>" +
        "<th align='center' style='width: 50px;'>" +
        "<a class='clear-all-single'>" +
        "Clear all" +
        "</a>" +
        "</th>" +
        "<th>" +
        "<b>Address</b>" +
        "</th>" +
        "<th>" +
        "<b>City</b>" +
        "</th>" +
        "<th>" +
        "<b>State</b>" +
        "</th>" +
        "<th>" +
        "<b>ZIP Code</b>" +
        "</th>" +
        "<th>" +
        "<b>Number</b>" +
        "</th>" +
        "<th>" +
        "<b>Radius</b>" +
        "</th>" +
        "<th>" +
        "<b>Keycode</b>" +
        "</th>" +
        "</tr>" +
        getRadiusRows(matches) +
        "</table>" +
        "</div>" +
        "<div class='matches-hint'>" +
        "To add more locations, search again" +
        "</div>" +
        "</div>";
}

function getRadiusRows(matches) {
    var rows = '';
    for (var i = 0; i < matches.length; i++) {
        var rowClass = (i % 2 != 0) ? 'radius-result-odd' : 'radius-result-even';
        rows = rows + gerRadiusRow(rowClass, matches[i]);
    }
    return rows;
}

function gerRadiusRow(rowClass, match) {
    var address = match.Address != null ? match.Address : '',
        city = match.City != null ? match.City : '',
        state = match.State != null ? match.State : '',
        zipCode = match.ZipCode != null ? match.ZipCode : '',
        count = match.RequestedCount != null ? match.RequestedCount : '',
        distance = match.MaxDistance != null ? match.MaxDistance : '',
        latitude = match.Latitude != null ? match.Latitude : '',
        keyCode = match.KeyCode != null ? match.KeyCode : '',
        longitude = match.Longitude != null ? match.Longitude : '';

    return "<tr class='" + rowClass + "'>" +
        "<td align='center'>" +
        "<input type='checkbox' class='match-result-input' checked='checked' data-latitude='" + latitude + "' data-longitude=' " + longitude + "' data-maxdistance='" + distance + "' data-address='" + address + "' data-city='" + city + "' data-state='" + state + "' data-zipcode='" + zipCode + "' data-keycode='" + keyCode + "' data-requestedcount='" + count + "' />" +
        "</td>" +
        "<td>" +
            address +
        "</td>" +
        "<td>" +
            city +
        "</td>" +
        "<td>" +
            state +
        "</td>" +
        "<td>" +
            zipCode +
        "</td>" +
        "<td>" +
            count +
        "</td>" +
        "<td>" +
            distance +
        "</td>" +
        "<td>" +
            keyCode +
        "</td>" +
        "</tr>";
}

function getInvalidInputsData(matches, matchText) {
    return "<div class='radius-results-data'>" +
        "<div class='match-locations'>" +
        "<div>" +
            matchText +
        "</div>" +
        "</div>" +
        "<div class='match-location-data'>" +
        "<table cellpadding='4' cellspacing='0' border='0' width='100%'>" +
        "<tr style='background-color: #E7E7E7;'>" +
        "<th align='center' style='width: 50px;'>" +
        "<b>Line #</b>" +
        "</th>" +
        "<th>" +
        "<b>Text</b>" +
        "</th>" +
        "<th>" +
        "<b>Error</b>" +
        "</th>" +
        "</tr>" +
        getInvalidInputsRows(matches) +
        "</table>" +
        "</div>" +
        "</div>";
}

function getInvalidInputsRows(matches) {
    var rows = '';
    for (var i = 0; i < matches.length; i++) {
        var rowClass = (i % 2 != 0) ? 'radius-result-odd' : 'radius-result-even';
        rows = rows + gerInvalidInputRow(rowClass, matches[i]);
    }
    return rows;
}

function gerInvalidInputRow(rowClass, match) {
    var line = match.Line != null ? match.Line : '',
        text = match.Text != null ? match.Text : '',
        error = match.Error != null ? match.Error : '';

    return "<tr class='" + rowClass + "'>" +
        "<td>" +
            line +
        "</td>" +
        "<td>" +
           text +
        "</td>" +
        "<td>" +
            error +
        "</td>" +
        "</tr>";
}
